<template>
	<div class="footer_box" id="contacts">
		<div class="footer_content">
			<div class="footer_content_col1">
				<div class="footer_content_col1_box">
					<div class="footer_content_col1_title">DOLPHIN<br>PLANET</div>
					<div class="style_line" style="height: 1px; border-bottom: 1px solid #A6CBD3;width: 100%;">
					</div>
					<div class="footer_content_col1_subtitle">
						HOTEL & SPA
					</div>
					<div class="footer_content_menu_box">
						<router-link  :to="{name: 'privacy_policy'}">
							политика конфиденциальности
						</router-link>
						<router-link  :to="{name: 'cookies_policy'}">
							политика использования файлов куки
						</router-link>
						<router-link  :to="{name: 'user_agreement'}">
							пользовательское соглашение
						</router-link>
						<router-link  :to="{name: 'refunds_cancellations'}">
							возврат и отмена
						</router-link>
<!--						<pdf src="../assets/pdf/user_agreement.pdf"-->
<!--						>-->
<!--							пользовательское соглашение-->
<!--						</pdf>-->
<!--						<pdf src="../assets/pdf/user_agreement.pdf">-->
<!--							возврат и отмена-->
<!--						</pdf>-->
					</div>
				</div>
			</div>
			<div class="footer_content_col2">
				<div class="footer_content_col2_subcol_box">
					<table>
						<tbody>
							<tr>
								<td style="padding: 0 0.6em">
									<a href="tel:+74852620011">
										<img src="../assets/img/footer/Vector.svg" alt="">
									</a>
								</td>
								<td><a href="tel:+74852620011">+7(4852)62-00-11</a></td>
								<td>
									<a href="https://vk.com/yar.delfin" target="_blank">
										<img style="width: 35px; height: 35px;" v-if="$store.getters.screenWidth > 575" src="../assets/img/footer/vk.svg" alt=""/>
									</a>
								</td>
							</tr>
							<tr>
								<td style="padding: 0 0.6em;">
									<a href="mailto:info@yardelfin.ru">
										<img src="../assets/img/footer/Vector-2.svg" alt="">
									</a>
								</td>
								<td><a href="mailto:info@yardelfin.ru">info@yardelfin.ru</a></td>
								<td>
									<a href="https://t.me/dolphin_planet" target="_blank">
										<img style="width: 35px; height: 35px;" v-if="$store.getters.screenWidth > 575" src="../assets/img/footer/telegram.svg" alt=""/>
									</a>
								</td>
							</tr>
							<tr >
								<td style="padding: 0.3em;"></td>
								<td style="font-size: 0.4em;letter-spacing: 0.1em;">Ярославская область, Ярославский район,<br> п. Дубки, ул. Школьная, д. 1</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
				<MapComponent/>
			</div>
		</div>
		<div v-if="$store.getters.screenWidth > 575">
			<br>
			<br>
			<br>
		</div>
	</div>
</template>

<script>
import MapComponent from './MapComponent.vue'


export default {

	name: "FooterComponent",
	components: {
		MapComponent,
	},

	computed: {

	},
	setup() {

	},

	data() {
		return {
		}
	},

}
</script>

<style>
.footer_box {
	min-height: 90vh;
	display: flex;
	align-items: start;
	position: relative;
	width: 100%;
	flex-direction: column;
	flex-wrap: nowrap;
	background-color: #242424;
	margin: 0px;
	padding: 0px;
	padding-top: 5em;
	overflow: hidden;
	z-index: 5;
}
.footer_content {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-content: flex-start;
	justify-content: space-around;
	align-items: flex-start;
	padding: 0em 3em;
}
.footer_content_col1, .footer_content_col2 {
	color: #A6CBD3;
	font-weight: 200;
	font-size: 2em;
	letter-spacing: 0.15em;
}
.footer_content_col1 {
	/*width: 40%;*/

}
.footer_content_col2 {
	width: 60%;
}

/*.footer_content_col2 div {*/
/*	padding-bottom: 0.3em;*/
/*}*/
.footer_content_col2 a {
	color: #A6CBD3;
	font-size: 0.8em;
}

.footer_content_col2_subcol_box {
	display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: flex-end;
    align-items: flex-start;
	height: auto;

}
/*.footer_content_col2_subcol1 {*/
/*	height: 100%;*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*    justify-content: space-around;*/
/*    align-items: flex-end;*/
/*}*/
.footer_content_col2_subcol_box a:hover {
	color: white;

}

.footer_content_col2_subcol1 img,
.footer_content_col2_subcol1 div {
	display: flex;
}
.footer_content_col2_subcol2 {
	height: 100%;
	display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: flex-end;
    justify-content: flex-start;
    align-items: flex-end;
}

.footer_content_col1_title {
	padding-bottom: 0.3em;
	margin-bottom: 0.3em;
}

.footer_content_col1_subtitle {
	padding-top:  0.4em;
	font-size: 0.4em;
	font-family: 'Involve';
	letter-spacing: 0.5em !important;
}
.footer_content_menu_box {
	padding-top: 1em;
	display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
}


.footer_content_menu_box a:hover,
.footer_content_menu_box a {
	font-size: 0.5em;
	letter-spacing: 0.04em !important;
	color: #A6CBD3;
	padding-top: 1em;
	/*padding-bottom: 0.5em;*/
}


@media (max-width: 575px) {
	.footer_content {
		width: 100%;
        display: flex;
        align-content: center;
        justify-content: flex-start;
        align-items: stretch;
        flex-direction: column;
        flex-wrap: nowrap;
		padding: 0em;
	}
	.footer_content_col1_title {
		font-size: 1.3em;
		border-bottom: 1px solid  #A6CBD3;
	}
	.footer_content_col1_subtitle  {

	}
	.footer_content_col1_box {
		display: flex;
		flex-direction: column;
		padding: 0em 1.5em;
        align-items: flex-start;
        align-content: flex-start;
        justify-content: center;
	}
	.style_line{
		display: none;
	}

	.footer_content_col2 {
		width: 100%;

	}
	.footer_content_col2_subcol_box {
		padding: 1em 0;
        display: flex;
        font-size: 0.8em;
        flex-direction: row;
        align-content: center;
        justify-content: center;
        align-items: flex-start;
        height: auto;
	}
}
</style>